import React, { SyntheticEvent } from 'react';
import cn from 'classnames';
import cloneDeep from 'lodash/cloneDeep';
import IDeal from '@/finsight/domain/vo/IDeal';
import Tools from './Tools/Tools';
import Dates from './Dates/Dates';
import Leads from './Leads/Leads';
import Region from './Region/Region';
import DealStatus from '@/finsight/ui/common/components/TableCells/DealStatus';
import ParentCompany from './ParentCompany/ParentCompany';
import TickerDealName from './TickerDealName/TickerDealName';
import SectorIndustry from './SectorIndustry/SectorIndustry';
import ProductAbbreviation from './ProductAbbreviation/ProductAbbreviation';
import { mapDealFields } from '@/finsight/ui/components/deals/DealsList/DealHeader/helpers';
import UpsizedDeal from '@/finsight/ui/components/deals/DealsList/DealHeader/UpsizedDeal/UpsizedDeal';

import styles from './dealHeader.scss';

interface IDealHeaderProps {
  isFirst: boolean,
  isLast: boolean,
  isExpanded: boolean,
  deal: IDeal,
  onClick?: (deal: string) => void,
}

const DealHeader = (props: IDealHeaderProps) => {
  const deal = mapDealFields(cloneDeep(props.deal));
  const { isExpanded, isFirst } = props;

  const onHeaderClick = (event : SyntheticEvent) => {
    event.stopPropagation();
    props.onClick(deal.id);
  };

  return deal && deal.id && (
    <>
      <div
        className={ cn(styles.header, { [styles.isFirst]: isFirst, [styles.isCollapsed]: !isExpanded }) }
        onClick={ onHeaderClick }
      >
        <ProductAbbreviation deal={ deal } />
        <SectorIndustry deal={ deal } />
        <UpsizedDeal deal={ deal } />
        <DealStatus status={ deal.status } />
        <TickerDealName deal={ deal } />
        <ParentCompany deal={ deal } />
        <Leads deal={ deal } isLast={ props.isLast } />
        <Region deal={ deal } />
        <Dates deal={ deal } />
        <Tools
          deal={ deal }
          isExpanded={ props.isExpanded }
        />
      </div>
    </>
    );
};

export default DealHeader;
